import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Phone } from 'lucide-react';
import useSiteImages from '../hooks/useSiteImages';
import { useAboutData } from '../hooks/useAboutData';
import { useCompanyInfo } from '../hooks/useCompanyInfo';
import './About.css';

const About = () => {
  const { getImage } = useSiteImages();
  const { aboutData } = useAboutData();
  const { companyInfo } = useCompanyInfo();

  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Über uns | Nessenius Garten & Landschaftsbau';
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Lernen Sie Nessenius Garten & Landschaftsbau kennen. Ihr lokaler Garten- und Landschaftsbau-Fachbetrieb in Nörten-Hardenberg. Erfahrung, Qualität und persönlicher Service.');
  }, []);

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>Über uns</h1>
          <p>Ihr lokaler Partner für professionelle Gartenarbeiten</p>
        </div>
      </section>

      <section className="about-content-section">
        <div className="container">
          <div className="about-content-grid">
            <div className="about-text">
              <h2 className="heading-2">{aboutData.title}</h2>
              <div className="about-description body-large" style={{ marginTop: '24px', whiteSpace: 'pre-line' }}>
                {aboutData.text}
              </div>
            </div>
            
            <div className="about-image-wrapper">
              <img 
                src={getImage('about_team')} 
                alt="Nessenius Garten & Landschaftsbau Team" 
                className="about-image"
              />
            </div>
          </div>

          <div className="values-section">
            <h2 className="heading-2" style={{ textAlign: 'center', marginBottom: 'var(--spacing-xl)' }}>
              Unsere Werte
            </h2>
            <div className="values-grid">
              {aboutData.values.map((value, index) => (
                <div key={index} className="value-card network-card">
                  <div className="value-icon">
                    <CheckCircle size={32} />
                  </div>
                  <h3 className="heading-3">{value.title}</h3>
                  <p className="body-medium" style={{ marginTop: '12px', color: 'var(--text-secondary)' }}>
                    {value.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="about-owner-section network-card">
            <div className="owner-info">
              <h3 className="heading-2">Inhaber: {companyInfo.owner}</h3>
              <p className="body-large" style={{ marginTop: '16px', color: 'var(--text-secondary)' }}>
                Mit Herzblut und Fachkompetenz für Ihren Garten im Einsatz
              </p>
              <div className="owner-contact">
                <a href={`tel:${companyInfo.contact.phone}`} className="btn-primary" style={{ marginTop: '24px' }}>
                  <Phone size={18} style={{ marginRight: '8px', display: 'inline-block', verticalAlign: 'middle' }} />
                  Persönlich kontaktieren
                </a>
              </div>
            </div>
          </div>

          <div className="about-cta">
            <h2 className="heading-2">Lernen Sie uns kennen</h2>
            <p className="body-large" style={{ marginTop: '16px', color: 'var(--text-secondary)' }}>
              Überzeugen Sie sich selbst von unserer Arbeit und lassen Sie uns gemeinsam Ihr Gartenprojekt verwirklichen
            </p>
            <Link to="/kontakt" className="btn-cta" style={{ marginTop: '24px' }}>
              Jetzt Kontakt aufnehmen
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
